import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Filter, Search } from "lucide-react";

export const ClientsListSkeleton = () => {
    return (
        <div className="min-h-screen bg-muted dark:bg-background animate-pulse">
            {/* Header Skeleton */}
            <header className="border-b bg-foreground text-background">
                <div className="container mx-auto px-6 py-4">
                    <div className="flex items-center justify-between">
                        <div>
                            <Skeleton className="h-8 w-64 mb-2 bg-muted/20" />
                            <Skeleton className="h-4 w-48 bg-muted/20" />
                        </div>
                    </div>
                </div>
            </header>

            <main className="container mx-auto px-6 py-8 space-y-6">
                {/* Filters Card Skeleton */}
                <Card className="border-border shadow-lg">
                    <CardHeader>
                        <CardTitle className="text-lg font-semibold flex items-center gap-2">
                            <Filter className="h-5 w-5 text-muted-foreground" />
                            <Skeleton className="h-6 w-24" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid gap-4 md:grid-cols-4">
                            <div className="md:col-span-3">
                                <Skeleton className="h-10 w-full" /> {/* Search Input */}
                            </div>
                            <div>
                                <Skeleton className="h-10 w-full" /> {/* Region Select */}
                            </div>
                        </div>
                        <div className="mt-4">
                            <Skeleton className="h-9 w-32" /> {/* Clear Filters Button */}
                        </div>
                    </CardContent>
                </Card>

                {/* Clients Table Skeleton */}
                <Card className="border-border shadow-lg">
                    <CardContent className="p-0">
                        <div className="rounded-md border border-border">
                            <Table>
                                <TableHeader>
                                    <TableRow>
                                        {[...Array(7)].map((_, i) => ( // 6 columns in the actual table
                                            <TableHead key={i}><Skeleton className="h-4 w-full" /></TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {[...Array(5)].map((_, i) => ( // 5 rows of skeleton data
                                        <TableRow key={i}>
                                            {[...Array(7)].map((_, j) => ( // 6 columns
                                                <TableCell key={j}><Skeleton className="h-5 w-full" /></TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </CardContent>
                </Card>

                {/* Pagination Controls Skeleton */}
                <Card className="border-border">
                    <CardContent className="pt-6">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                            <Skeleton className="h-8 w-32" /> {/* Items per page select */}
                            <Skeleton className="h-5 w-24" /> {/* Page info */}
                            <div className="flex items-center gap-2">
                                <Skeleton className="h-9 w-24" /> {/* Previous button */}
                                <Skeleton className="h-9 w-24" /> {/* Next button */}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </main>
        </div>
    );
};
